<script lang="ts">
	import { getContext, onMount } from "svelte"
	import { SidebarController } from "./SidebarController.svelte"
	import { CollapsibleSectionNoBind } from "misc-ui"
	import { Responsive } from "responsive"
	import { ImageModifierController } from "../ImageModifierController.svelte"

	let expandHelp = $derived(SidebarController.showDetails)
	let controller = getContext<ImageModifierController>("controller")

	function cancel() {
		controller.imageEditor.editor.mode.cancel()
	}

	function complete() {
		controller.imageEditor.editor.mode.get().complete()
	}

	function handleModeComplete() {
		SidebarController.setView("default")
	}

	onMount(() => {
		const eventControls = controller.imageEditor.editor.mode.on("deactivated", handleModeComplete)
		return eventControls.remove
	})
</script>

<div class="mask-edit-menu">
	<CollapsibleSectionNoBind expanded={expandHelp} onclick={SidebarController.toggleDetails}>
		{#snippet header()}
			<div class="heading">
				<h3>Edit mask</h3>
				<button class="info-heading link-button small"
					>{expandHelp ? "Hide" : "More"} details</button
				>
			</div>
		{/snippet}
		{#snippet content()}
			<ul>
				<li>
					{Responsive.isMobile ? "Tap" : "Click"} and drag a point to move it
				</li>
				<li>
					{Responsive.isMobile ? "Double tap" : "Click"} on the line to add a point
				</li>
				{#if !Responsive.isMobile}
					<li>Click on a point while holding alt to remove it</li>
				{/if}
				<li>
					{Responsive.isMobile ? "Tap" : "Click"} complete
					<p class="info">This will save the mask and take you back to the mask selector</p>
				</li>
			</ul>
		{/snippet}
	</CollapsibleSectionNoBind>
	<hr />

	<br />
</div>
<div class="button-container" id="edit-buttons">
	<button class="outline-button sidebar-button warn" onclick={cancel}>Cancel</button>
	<button class="outline-button sidebar-button" onclick={complete}>Complete</button>
</div>

<style>
	h3 {
		font-size: var(--h0);
		margin: 0;
	}

	.mask-edit-menu {
		flex-grow: 1;
	}

	.button-container,
	.mask-edit-menu {
		padding-right: 0.5rem;
	}

	.button-container {
		margin-bottom: 0;
		justify-content: flex-end;
	}

	:global(.isMobile) .mask-edit-menu {
		padding-right: 0;
		flex-grow: 0;
	}

	:global(.isMobile #sidebar) .button-container#edit-buttons {
		position: fixed;
		bottom: 0.5rem;
		left: 0;
		width: 100%;
		padding: 0 0.5rem;
		z-index: 1;
	}

	:global(.isMobile #sidebar) .button-container#edit-buttons button {
		flex-basis: calc(50% - 0.25rem);
		text-align: center;
		font-size: var(--h2);
	}
</style>
